import React from 'react';

/**
 * Allows us to reuse the `ref` from `forwardRef` within the component
 * See https://itnext.io/reusing-the-ref-from-forwardref-with-react-hooks-4ce9df693dd
 */
export function useCombinedRef<T>(...refs: Array<React.RefCallback<T> | null | undefined | React.MutableRefObject<T | null>>) {
  const targetRef = React.useRef<T>(null);

  React.useEffect(() => {
    refs.forEach(ref => {
      if (!ref) return;

      if (typeof ref === 'function') {
        ref(targetRef.current);
      } else {
        ref.current = targetRef.current;
      }
    });
  }, [refs]);

  return targetRef;
}
